import css from "../PaymentTopUpAccountModal/PaymentTopUpAccountModal.module.css";

import { useEffect, useRef, useState } from "react";
import {
  selectIsLoading,
  selectPosts,
} from "../../../redux/settings/selectors.js";
import { useSelector } from "react-redux";
import {
  selectInvoiceDataLoading,
  selectTariffsError,
  selectTariffsList,
  selectTariffsLoading,
} from "../../../redux/tariffs/selectors.js";
import LoaderSvg from "../../Loader/LoaderSvg.jsx";
import { useDispatch } from "react-redux";
import {
  generateInvoice,
  getTariffs,
} from "../../../redux/tariffs/operations.js";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import {
  BsShopWindow,
  BsCheck2,
  BsFillPersonFill,
  BsGearFill,
  BsCameraVideo,
  BsInfinity,
  BsHandIndex,
} from "react-icons/bs";
import { showToast } from "../../../utils/showToast.js";
import { getPosts } from "../../../redux/settings/operations.js";
import { selectTariffsInfo } from "../../../redux/service/selectors.js";
import { useCan } from "../../../utils/permissions.js";
import ModalCloseIcon from "../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

const features = [
  { code: "AI‑відео" },
  { code: "Користувачі CRM-системи" },
  { code: "Інтеграція - ", subCode: "постачальники" },
  { code: "Додаток клієнта" },
  { code: "Аналітика" },
  { code: "WEB розширення" },
];

const featureLimitMap = {
  "AI‑відео": "ai_video",
  "Користувачі CRM-системи": "users",
  "Інтеграція - ": "integration_suppliers",
  // "Додаток механіка": "mech_app_users",
  "Додаток клієнта": "app_client",
};

const renderLimitValue = value => {
  if (value === -1) {
    return <BsInfinity className={css.infinityIcon} />;
  }

  if (value === true) {
    return "Так";
  }

  if (value === false || value === 0) {
    return "0";
  }

  return value;
};

const isFeatureAvailable = value => {
  return value !== 0 && value !== false;
};

export default function PaymentTopUpAccountModal({
  onClose,
  fromLoginForm = false,
}) {
  const dispatch = useDispatch();
  const posts = useSelector(selectPosts);
  const postsLoading = useSelector(selectIsLoading);
  const tariffsLoading = useSelector(selectTariffsLoading);
  const invoiceDataLoading = useSelector(selectInvoiceDataLoading);
  const companyTariffs = useSelector(selectTariffsList);
  const [tariffs, setTariffs] = useState([]);
  const tariffsError = useSelector(selectTariffsError);
  const currentTariffInfo = useSelector(selectTariffsInfo);
  const ownerEmail = currentTariffInfo?.owner?.email || "";
  const workshopId = currentTariffInfo?.workshop_id || "";
  const [remainingDaysTillDelete, setRemainingDaysTillDelete] = useState(false);

  const can = useCan();

  console.log("tariffs", tariffs);
  console.log("currentTariffInfo", currentTariffInfo);

  useEffect(() => {
    if (!tariffsError) return;

    showToast(
      { title: "Вибачте, сталася помилка", description: tariffsError?.details },
      "error"
    );
  }, [tariffsError, onClose]);

  useEffect(() => {
    const now = new Date();
    const paidUntil = new Date(currentTariffInfo?.paid_until);

    const twentyOneDaysFromPaidUntil = new Date(paidUntil);
    twentyOneDaysFromPaidUntil.setDate(
      twentyOneDaysFromPaidUntil.getDate() + 21
    );

    // Кількість календарних днів до завершення терміну
    const remainingDays = Math.max(
      0,
      Math.ceil(
        (Date.UTC(
          twentyOneDaysFromPaidUntil.getFullYear(),
          twentyOneDaysFromPaidUntil.getMonth(),
          twentyOneDaysFromPaidUntil.getDate()
        ) -
          Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) /
          (1000 * 60 * 60 * 24)
      )
    );

    setRemainingDaysTillDelete(remainingDays);
  }, [currentTariffInfo]);

  useEffect(() => {
    dispatch(getPosts());
    dispatch(getTariffs());
  }, [dispatch]);

  useEffect(() => {
    if (companyTariffs?.length) {
      setTariffs(companyTariffs);
    }
  }, [companyTariffs]);

  const [isYear, setIsYear] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const scrollerRef = useRef(null);

  const toggleSwitch = () => {
    setIsYear(!isYear);
  };

  const scrollByCard = (direction = 1) => {
    if (!scrollerRef.current) return;

    const card = scrollerRef.current.querySelector(`.${css.cardWrapper}`);
    if (!card) return;

    const gap = 20; // має відповідати gap у CSS
    const scrollAmount = card.offsetWidth + gap;

    scrollerRef.current.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  };

  const checkButtons = () => {
    if (scrollerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollerRef.current;

      // Якщо скрол більше 0, можна йти назад
      setCanScrollLeft(scrollLeft > 0);

      // Якщо поточний скрол + ширина контейнера менше загальної ширини контенту — можна йти вперед
      // Використовуємо -1 для запобігання похибок округлення пікселів
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    }
  };

  useEffect(() => {
    checkButtons(); // Перевірка при першому рендері
    window.addEventListener("resize", checkButtons); // На випадок зміни розміру екрана
    return () => window.removeEventListener("resize", checkButtons);
  }, [tariffs]);

  const onPaymentBtnClick = tariff => {
    const { name, price } = tariff;

    const noRightsToPay = {
      title: "Недостатньо прав для зміни тарифу",
      description: `Зверніться до власника автосервісу ${[
        currentTariffInfo?.owner?.first_name,
        currentTariffInfo?.owner?.last_name,
      ]
        .filter(Boolean)
        .join(" ")} для продовження і оплати тарифу.`,
    };

    if (!can("invoices", "create") && !fromLoginForm) {
      showToast(noRightsToPay, "error");
      return;
    }
    if (!currentTariffInfo?.can_create_invoice && fromLoginForm) {
      showToast(noRightsToPay, "error");
      return;
    }

    const paymentSum = isYear ? Number(price) * 0.8 * 12 : Number(price);

    const overPostsLimit =
      tariff?.limits?.posts !== -1 &&
      currentTariffInfo?.posts_count > tariff?.limits?.posts;

    const overCamerasLimit =
      tariff?.limits?.ai_video !== -1 &&
      currentTariffInfo?.cameras_count > tariff?.limits?.ai_video;

    const overUsersLimit =
      tariff?.limits?.users !== -1 &&
      currentTariffInfo?.employees_count > tariff?.limits?.users;

    const overWorkshopsLimit =
      tariff?.limits?.workshops !== -1 &&
      currentTariffInfo?.workshops_count > tariff?.limits?.workshops;

    if (!ownerEmail || !name || !paymentSum) {
      showToast(
        {
          title: "Щось пішло не так",
          description: "Будь ласка, спробуйте ще раз.",
        },
        "error"
      );
      return;
    }

    // масив перевірок лімітів
    const limitChecks = [
      {
        over: overPostsLimit,
        label: `постів (${currentTariffInfo?.posts_count})`,
      },
      {
        over: overCamerasLimit,
        label: `камер (${currentTariffInfo?.cameras_count})`,
      },
      {
        over: overUsersLimit,
        label: `користувачів (${currentTariffInfo?.employees_count})`,
      },
      {
        over: overWorkshopsLimit,
        label: `СТО (${currentTariffInfo?.workshops_count})`,
      },
    ];

    const exceeded = limitChecks.filter(c => c.over).map(c => c.label);

    if (exceeded.length > 0) {
      showToast(
        {
          title: "Тарифний план не підходить",
          description: `Він не підтримує поточну кількість ${exceeded.join(", ")}. Будь ласка, виберіть інший тариф.`,
        },
        "error"
      );
      return;
    }

    const userData = {
      user_email: ownerEmail,
      tariff_name: name,
      amount: paymentSum,
      currency: tariff.currency,
      success_url: "https://app.crmmech.com/login",
      cancel_url: "https://app.crmmech.com/login",
      workshop_id: workshopId,
      duration_months: isYear ? 12 : 1,
      promo_code: promoCode.trim() || "",
    };

    dispatch(generateInvoice(userData))
      .unwrap()
      .then(res => {
        const pageUrl = res.payment_link;
        if (!pageUrl) return;
        window.location.href = pageUrl;
        onClose();
      })
      .catch(() => {
        console.error("Помилка при створенні інвойсу");
      });
  };

  const pluralizePost = count => {
    const lastTwo = count % 100;
    const last = count % 10;

    if (lastTwo >= 11 && lastTwo <= 14) {
      return "постів";
    }

    if (last === 1) {
      return "пост";
    }

    if (last >= 2 && last <= 4) {
      return "пости";
    }

    return "постів";
  };

  return (
    <div className={css.paymentModal}>
      {postsLoading || tariffsLoading || invoiceDataLoading ? (
        <LoaderSvg />
      ) : (
        <>
          <ModalCloseIcon onClose={onClose} />
          <div className={css.headerWrapper}>
            <h2 className={css.header}>Тарифи</h2>
            <div className={css.line}></div>
            <p
              className={`${css.headerText} ${currentTariffInfo?.status === "expired" ? css.expiredText : ""}`}
            >
              {currentTariffInfo?.status === "expired"
                ? `Будь ласка, оплатіть тариф. Якщо ви не продовжите тариф, ваш акаунт буде видалено через ${remainingDaysTillDelete} днів.`
                : "Все включено: камери, CRM, додатки, підтримка. Безкоштовний тест: 14 днів, без картки."}
            </p>
            <div className={css.toggleWithTextWrapper}>
              <p className={css.rightText}>Раз на місяць</p>
              <label className={css.toggleSwitch}>
                <input
                  type="checkbox"
                  checked={isYear}
                  onChange={toggleSwitch}
                />
                <span className={css.slider} />
              </label>
              <p className={css.rightText}>за рік</p>
              <p className={css.discount}>20% знижка</p>
            </div>
            <div className={css.promoWrapper}>
              <input
                className={css.promoInput}
                type="text"
                placeholder="Промокод"
                value={promoCode}
                onChange={e => setPromoCode(e.target.value)}
              />
            </div>
          </div>
          {tariffs.length === 0 ? (
            <div className={css.noTariffsError}>Тарифи не знайдені</div>
          ) : (
            <div className={css.cardsWrapper}>
              <button
                type="button"
                className={css.arrow}
                onClick={() => scrollByCard(-1)}
                disabled={!canScrollLeft}
              >
                <MdArrowBackIos />
              </button>
              <div
                className={css.scrollWrapper}
                ref={scrollerRef}
                onScroll={checkButtons}
              >
                {[...tariffs]
                  ?.filter(
                    tariff =>
                      tariff.name !== "Free" && tariff.name !== "Network"
                  )
                  .sort((a, b) => Number(a.price) - Number(b.price))
                  .map((tariff, index) => (
                    <div
                      key={index}
                      className={`${css.cardWrapper} ${
                        tariff.name === "Profi" && css.profi
                      }`}
                    >
                      <div className={`${css.stringWrapper} ${css.topString}`}>
                        <h3
                          className={` 
            ${tariff?.name === "Profi" ? css.textPurple : css.textBlue} 
            ${css.cardHeader}`}
                        >
                          {tariff.name}
                        </h3>

                        <div className={css.rightHeaderWrapper}>
                          <BsShopWindow />

                          <p>{tariff?.limits?.posts}</p>

                          <p>{pluralizePost(tariff?.limits?.posts)}</p>
                        </div>
                      </div>

                      <div
                        className={`${css.stringWrapper} ${css.secondString}`}
                      >
                        <div className={css.paymentInfoWrapper}>
                          {isYear && (
                            <p className={css.fullPrice}>₴{tariff?.price}</p>
                          )}

                          <p className={css.price}>
                            {tariff?.currency === "EUR"
                              ? "€"
                              : tariff?.currency === "UAH"
                                ? "₴"
                                : tariff?.currency === "USD"
                                  ? "$"
                                  : ""}
                            {!isYear
                              ? tariff?.price
                              : Number(tariff?.price) * 0.8}
                          </p>

                          {tariff?.name === "Full" && isYear ? (
                            <p className={css.paymentInfo}>/міс за локацію</p>
                          ) : tariff?.name === "Full" ? (
                            <p className={css.paymentInfo}>/міс</p>
                          ) : (
                            <p className={css.paymentInfo}>/міс за локацію</p>
                          )}
                        </div>
                      </div>

                      <div className={css.listWrapper}>
                        {features.map((feature, index) => {
                          const limitKey = featureLimitMap[feature.code];

                          const limitValue = limitKey
                            ? tariff?.limits?.[limitKey]
                            : null;

                          const isAvailable =
                            limitKey !== undefined
                              ? isFeatureAvailable(limitValue)
                              : true;

                          return (
                            <div className={css.listString} key={index}>
                              <BsCheck2
                                className={`${css.checkIcon} ${
                                  isAvailable
                                    ? css.trueCheckIcon
                                    : css.falseCheckIcon
                                }`}
                              />

                              <p
                                className={`${css.listText} ${
                                  isAvailable
                                    ? css.trueListText
                                    : css.falseListText
                                }`}
                              >
                                {feature?.code}

                                {feature?.subCode && (
                                  <span className={css.suppliers}>
                                    {feature?.subCode}
                                  </span>
                                )}
                              </p>

                              {limitKey && (
                                <div className={css.quantityWrapper}>
                                  {(feature.code === "CRM / Облік / Склади" ||
                                    feature.code === "Додаток механіка" ||
                                    feature.code === "Додаток клієнта") && (
                                    <BsFillPersonFill
                                      className={css.listIcon}
                                    />
                                  )}

                                  {feature.code === "Інтеграція - " && (
                                    <BsGearFill className={css.listIcon} />
                                  )}

                                  {feature.code === "AI‑відео" && (
                                    <BsCameraVideo className={css.listIcon} />
                                  )}

                                  <p className={css.quantityText}>
                                    {renderLimitValue(limitValue)}
                                  </p>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      <div
                        className={`${css.stringWrapper} ${css.thirdString}`}
                      >
                        <p className={css.suppliers}>Apps — iOS/Android</p>
                        <p className={css.paymentInfo}>скоро</p>
                      </div>

                      <button
                        className={`${
                          tariff.name === "Profi"
                            ? css.btnGradient
                            : css.btnBlue
                        } ${css.cardBtn}`}
                        onClick={() => onPaymentBtnClick(tariff)}
                      >
                        <BsHandIndex />
                        {`Обрати ${tariff.name}`}
                      </button>
                    </div>
                  ))}
              </div>
              <button
                type="button"
                className={css.arrow}
                onClick={() => scrollByCard(1)}
                disabled={!canScrollRight}
              >
                <MdArrowForwardIos />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
